<template lang="pug">
  #login
    success-msg(v-if="alertTxt" :successText="alertTxt")
    spinner(v-if="showLoading")
    common-public(v-else title-key="login.title")
      b-form(
        novalidate,
        @submit.prevent="submit")
        b-container(fluid)
          b-row
            b-col(cols="3")
            b-col(cols="6")
              bkn-errors-banner()
              b-card
                b-form-group(
                  class="vertical"
                  :label="$t('login.nif')"
                  label-for="userData.nif"
                  :invalid-feedback="veeErrors.first('userData.nif')"
                  :state="state('userData.nif')")
                  b-form-input(
                    type="text"
                    v-model="userData.nif"
                    name="userData.nif"
                    :data-vv-as="$t('login.validate.nif')"
                    v-validate="'required'"
                    :state="state('userData.nif')")

                b-form-group(
                  class="vertical"
                  :label="$t('login.user')"
                  label-for="userData.user"
                  :invalid-feedback="veeErrors.first('userData.user')"
                  :state="state('userData.user')")
                  b-form-input(
                    type="text"
                    maxlength="40"
                    v-model="userData.user"
                    name="userData.user"
                    :data-vv-as="$t('login.validate.user')"
                    v-validate="'required'"
                    :state="state('userData.user')")
                    
                b-form-group(
                  class="vertical"
                  :label="$t('login.password')"
                  label-for="userData.password"
                  :invalid-feedback="veeErrors.first('userData.password')"
                  :state="state('userData.password')")
                  b-form-input(
                    type="password"
                    maxlength="40"
                    v-model="userData.password"
                    name="userData.password"
                    :data-vv-as="$t('login.validate.password')"
                    v-validate="'required'"
                    :state="state('userData.password')")
                
                .clearAll
                  b-container.buttonContainer(fluid)
                    b-row.pt-2
                      b-btn(variant="primary" @click="doLogin" size="full") {{ $t('login.button') }}
                    //- Botón recovery queda oculto hasta validación
                    //- b-row.mt-2
                    //-   b-btn(variant="secondary" @click="doRecovery" size="full") {{ $t('login.recoveryButton') }}
</template>

<script>
import validable from '@/mixins/validable'
import stateableField from '@/mixins/stateableField'
import bknErrorsBanner from '@/components/shared/ErrorsBanner'
import session from '@/auth/session'
import redirectTo from '@/helpers/redirectTo'
import constants from '@/utils/constants'
import spinner from '@/components/shared/Spinner'
import successMsg from '@/components/shared/SuccessMsg'
import CommonPublic from '@/components/shared/CommonPublic'
import config from '@/utils/config'

export default {
  name: 'Login',
  mixins: [ validable, stateableField ],
  components: {
    bknErrorsBanner,
    spinner,
    successMsg,
    CommonPublic
  },
  created () {
    if (!session.isSupportSession()) {
      session.destroy()
    }
  },
  data () {
    return {
      oldVersion: config.urlOldVersion,
      showLoading: false,
      userData: {
        user: '',
        password: '',
        nif: ''
      }
    }
  },
  methods: {
    doLogin() {
      this.validatePromise()
        .then(() => {
          this.showLoading = true
          this.$router.push({ name: 'home', params: { loginData: this.userData } })
        })
        .catch(e => {
          // console.log(e)
        })
    },
    doRecovery () {
      redirectTo(constants.paths.recovery)
    }
  },
  computed: {
    errors: {
      get () {
        let msgSesionError = this.$t(this.$route.query.errorMsg) || ''
        if (msgSesionError) {
          this.$store.dispatch('errors/addServerError', { msg: msgSesionError })
        }
        return this.$store.state.errors.array.list
      }
    },
    alertTxt: {
      get () {
        return this.$t(this.$route.query.successMsg) || false
      }
    }
  },
  watch: {
    errors (n) {
      if (n && n.length > 0) {
        this.showLoading = false
      }
    }
  }
}
</script>
<style lang="scss">
  .oldversion a {
    font-size: inherit;
  }
  .header img {
    width: 150px !important;
  }
</style>
